/**
 * Screen snapshot of a doctype list (plan 1968 F13): visible column labels + the first
 * <= 20 visible rows exactly as the table renders them (" | "-joined) + the total.
 * Called ONCE in DocTypeListPageShell; attach the returned ref to the view container.
 *
 * Read from the rendered table at capture time, so every page's own cell formatting
 * (currency, status pills, dates) is reused as-is and nothing runs while the AI panel
 * is closed. Gallery / custom views without a <table> publish nothing -> text fallback.
 */

import { useRef } from "react";
import { useLocation } from "react-router-dom";
import { readDomTable } from "./screenDom";
import { useScreenCapture } from "./useScreenSection";

export const LIST_SCREEN_SECTION_ID = "list";

export interface ListScreenArgs {
  title?: string;
  total?: number;
  /** Changes when the visible rows change (e.g. the items array) -> open panel re-posts */
  version?: unknown;
}

export function useListScreenSection({ title, total, version }: ListScreenArgs) {
  const { pathname } = useLocation();
  const ref = useRef<HTMLDivElement>(null);
  useScreenCapture(
    LIST_SCREEN_SECTION_ID,
    () => {
      const table = readDomTable(ref.current, { total });
      return table ? { ...(title ? { title } : {}), table } : null;
    },
    { path: pathname, version },
  );
  return ref;
}
